import { MessageCircle } from 'lucide-react';
import { WHATSAPP_URL_CONV } from '../constants';
import { useScrollReveal } from '../hooks/useScrollReveal';

const logos = [
  { name: 'Bradesco Saúde', src: '/images/logos/bradesco.png' },
  { name: 'Amil',           src: '/images/logos/amil.png'     },
  { name: 'Cassi',          src: '/images/logos/cassi.png'    },
  { name: 'Asfeb',          src: '/images/logos/asfeb.png'    },
  { name: 'Fusex',          src: '/images/logos/fusex.png'    },
  { name: 'GEAP Saúde',     src: '/images/logos/geap.png'     },
  { name: 'Petrobras',      src: '/images/logos/petrobras.png'},
  { name: 'Planserv',       src: '/images/logos/planserv.png' },
  { name: 'Postal Saúde',   src: '/images/logos/postal.png'   },
  { name: 'SulAmérica',     src: '/images/logos/sulamerica.png'},
  { name: 'Saúde Caixa',    src: '/images/logos/saudecaixa.png'},
  { name: 'União Médica',   src: '/images/logos/uniaomed.png' },
  { name: 'Unimed',         src: '/images/logos/unimed.png'   },
];

export default function InsuranceSection() {
  const [ref, isVisible] = useScrollReveal();
  return (
    <section id="convenios" ref={ref} className={`py-24 md:py-32 bg-[#EEF4FF] transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
      <div className="max-w-7xl mx-auto px-4 lg:px-8">

        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="inline-flex items-center bg-[#0D47A1]/10 text-[#0D47A1] rounded-full px-4 py-1.5 text-sm font-semibold mb-4">
            Convênios Aceitos
          </div>
          <h2 className="font-poppins font-bold text-3xl sm:text-4xl text-[#212121] mb-4 leading-tight">
            Atendemos Seu Plano de Saúde
          </h2>
          <p className="text-base text-[#212121]/65">
            A maioria dos convênios cobre o procedimento — porque é tratamento, não cirurgia estética.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 mb-6">
          {logos.map((ins) => (
            <div
              key={ins.name}
              data-testid={`insurance-logo-${ins.name.toLowerCase().replace(/[\s\/]/g, '-')}`}
              className="bg-white border border-gray-100 rounded-xl px-5 py-4 flex flex-col items-center justify-center gap-2 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200"
              style={{ minHeight: '100px' }}
            >
              <div className="w-full h-10 flex items-center justify-center">
                <img
                  src={ins.src}
                  alt={ins.name}
                  className="h-10 w-auto max-w-full object-contain"
                  loading="lazy"
                />
              </div>
              <span className="text-[#212121]/60 text-xs font-medium text-center leading-tight">{ins.name}</span>
            </div>
          ))}
        </div>

        <div className="bg-white border border-[#0D47A1]/20 rounded-2xl p-6 md:p-8 max-w-2xl mx-auto text-center shadow-sm">
          <p className="text-[#212121]/75 text-base mb-4">
            Caso seu convênio não esteja na lista, entre em contato com a nossa equipe para verificação.
            A maioria dos planos tem cobertura para este procedimento.
          </p>
          <a
            href={WHATSAPP_URL_CONV}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="insurance-cta-button"
            className="inline-flex items-center gap-2 bg-[#0D47A1] text-white font-poppins font-semibold px-8 py-3.5 rounded-full hover:bg-[#00897B] transition-colors duration-200"
          >
            <MessageCircle size={18} />
            Consultar Convênios
          </a>
        </div>

      </div>
    </section>
  );
}
